"use client";

import { useEffect, useState } from "react";
import { getToken, isSupported } from "firebase/messaging";
import { messaging } from "../firebase";
import useNotificationPermission from "./useNotificationPermission";
import { AxiosPost_Nocatch } from "@/utilities/axioscall";
import { getuserid } from "@/utilities/sessionexpiry";
import { AK } from "@/constants";

export default function useFCMToken() {
  const { permission, requestPermission, showPrompt } = useNotificationPermission();
  const [fcmToken, setFcmToken] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

    const fetchToken = async () => {
      if (permission !== "granted") return;

      const supported = await isSupported();
      if (!supported) return;

      try {
        const token = await getToken(messaging(), {
          vapidKey:
            "BNpfqkcZEWQHFBjH5H-K8p7okFPicusCKk30WbPpMFBR8sPcmOmJPv57hzpZHEw78-WSX-tACMufnYOoiy3uB_k",
        });

        setFcmToken(token);
        await AxiosPost_Nocatch(AK.FCMPUSHAPI, {
          fcm_token: token,
          user_id: getuserid(),
        });
      } catch (err) {
        console.error("FCM token error:", err);
      }
    };

    fetchToken();
  }, [permission]);

  return { fcmToken, requestPermission, showPrompt };
}